import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { ResultProc } from '@app/models/system/result-proc.model';
import { OrderMstModel } from '@app/models/myoffice/order/order-mst.model';
import { CommonUtils } from '@app/common/util/common.util';
import { WAlertState } from '@app/selectors/w-alert.selector';
import { Store } from '@ngrx/store';
import { setWAlert } from '@app/actions/w-alert.action';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  constructor(private _http: HttpClient , private _wAlertStore: Store<WAlertState>
    , private _translate: TranslateService
  ) { }

  loadCartItems(userid: string): Observable<OrdPdtModel[]> {
    let url;
    url = `${environment.apiUrl}/ordreg/cart-list?comid=${environment.comId}&userid=${userid}`;
    return this._http.get<OrdPdtModel[]>(url);
  }

  loadCartInfo(userid: string, ctrCd: string): Observable<OrderMstModel> {
    let url
     url = `${environment.apiUrl}/ordreg/cart-info?comid=${environment.comId}&userid=${userid}&ctrCd=${ctrCd}`;
    return this._http.get<OrderMstModel>(url);
  }

  addToCart(params: any): Observable<ResultProc> {
    let url = `${environment.apiUrl}/ordreg/tmp-save`;
    return this._http.post<ResultProc>(url, {...params, lang: environment.default_lang});
  }

  removeCartItem(userid: string, pdtCd: string, ordNoTmp: number): Observable<ResultProc> {
    let url = `${environment.apiUrl}/ordreg/cart-del?comid=${environment.comId}&userid=${userid}&pdtCd=${pdtCd}&ordNoTmp=${ordNoTmp}`;
    return this._http.get<ResultProc>(url);
  }

  cancelOrder(userid: string, ordNoTmp: number): Observable<ResultProc> {
    let url = `${environment.apiUrl}/ordreg/tmp-del?comid=${environment.comId}&userid=${userid}&ordNoTmp=${ordNoTmp}`;
    return this._http.get<ResultProc>(url);
  }

  deleteAllSid(sid: string): Observable<ResultProc> {
    const url = `${environment.apiUrl}/ordreg/cart-del-SID?comid=${environment.comId}&sid=${sid}`;
    return this._http.get<ResultProc>(url);
  }

  deleteAllSidBeacon(sid: string): void {
    const url = `${environment.apiUrl}/ordreg/cart-del-SID?comid=${environment.comId}&sid=${sid}`;

    // sendBeacon chỉ cho phép gửi POST, nên ta dùng FormData rỗng
    const formData = new FormData();
    navigator.sendBeacon(url, formData);
  }

  private showAlertOnlyKindCart()
  {
    this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.successful, confirmBtnText: this._translate.instant('msg.cart.004'), message: this._translate.instant('msg.cart.003') } }));
  }
  
}